/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import styles from '../InviteTeamMember.module.css';
import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import { AdminSelect } from '@project/components';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';

export const TeamMemberRole = (props) => {
  const {roleOptions} = props;
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const form = useFormContext();

  useEffect(() => {
    form.setValue('companyRole', roleOptions[0]);
  }, [roleOptions]);

  const onRoleChange = (companyRole) => {
    form.setValue('companyRole', companyRole);
    if (companyRole.value === 'company-admin') {
      form.setValue('globalAccess', true);
      form.setValue('isCompanyAdmin', true);
    } else {
      form.setValue('isCompanyAdmin', false);
    }
  };

  return (
    <TwoColumnContent bottomBorder={true}>
      <LeftColumn>
        <TitleDescription title={t('InviteTeamMember.role.title')} description={t('InviteTeamMember.role.details')} />
      </LeftColumn>
      <RightColumn>
        <div>
          <AdminSelect
            id="role-select"
            propStyles={styles.adminSelect}
            label={t('InviteTeamMember.role.label')}
            options={roleOptions}
            value={form.watch('companyRole')}
            onChange={onRoleChange}
            isLoading={false}
          />
          <div className="pt-2">{form.watch('companyRole')?.desc }</div>
        </div>
      </RightColumn>
    </TwoColumnContent>
  );
};
